module.exports = __webpack_public_path__ + "static/media/4.43e14f36.svg";